module.exports = __webpack_public_path__ + "static/icons/icon-chevron-right-8d180cf5f6c73f959451a39332c184eb.svg";